export default __webpack_public_path__ + "static/media/clairefontaine8.c75bd4bb.jpg";